<template>
  <div class="container">
    <h4>Dlibr.ccdmd.qc.ca | Conditions d’utilisation</h4>
    <h5 class="mb-3 mt-5"><strong>Introduction</strong></h5>
    <p>
      Dlibr.ccdmd.qc.ca est un environnement numérique d’enseignement qui
      facilite l’évaluation pédagogique des arguments soumis pendant une
      délibération en ligne.
    </p>
    <h5 class="mb-3 mt-5">
      <strong>Utilisation pédagogique en tout temps </strong>
    </h5>
    <p>
      En cochant «J'accepte» et en utilisant Dlibr.ccdmd.qc.ca vous vous engagez
      à:
    </p>
    <ul>
      <li>
        Respecter les conditions d’utilisation; Être responsable du respect des
        règlements de votre établissement éducatif et des lois en vigueur au
        Canada et au Québec concernant l’utilisation des ressources numériques;
      </li>
      <li>
        Respecter la Loi sur le droit d’auteur Loi sur le droit d’auteur (L.R.C.
        (1985), ch. C-42) et, donc, à citer la source des informations utilisées
        et à recopier moins de 250 caractères de l’œuvre d’un tiers;
      </li>
      <li>
        Respecter la licence Creative Commons (CC BY-NC-SA 2.5 CA) pour le
        partage de vos publications
        (https://creativecommons.org/licenses/by-nc-sa/2.5/ca/deed.fr_CA).
      </li>
    </ul>
    <h5 class="mb-3 mt-5"><strong>Respect de la vie privée</strong></h5>
    <p>
      Vous consentez à ce que les informations personnelles suivantes soient
      collectées:
    </p>
    <ul>
      <li>Votre adresse courriel.</li>
      <li>Votre pseudonyme.</li>
      <li>Votre nom et prénom.</li>
    </ul>
    <p>
      Les données produites à partir de vos publications et de vos interactions
      seront toujours anonymisées dans le cas qu’elles soient affichées.
    </p>
    <p>Définition des « données anonymisées »:</p>
    <p>
      <small>
        « Données dont les informations nominatives ont été remplacées par un
        code d'identification, puis supprimées, de manière à rendre
        virtuellement impossible l'identification des individus auprès desquels
        elles ont été recueillies » (GDT, 2019).
        http://gdt.oqlf.gouv.qc.ca/ficheOqlf.aspx?Id_Fiche=26542437</small
      >
    </p>
    <p>
      Nous utilisons également des fichiers témoins, lesquels sont les données
      stockées sur votre ordinateur pour faciliter votre navigations. Les
      données recueillies vous concernant sont :
    </p>
    <ul>
      <li>les pages visitées et les requêtes;</li>
      <li>les heure et jour de connexion.</li>
    </ul>
    <p>
      Nous nous engageons à respecter les dispositions législatives énoncées
      dans la Loi sur l'accès aux documents des organismes publics et sur la
      protection des renseignements personnels.
    </p>
    <h5 class="mb-3 mt-5">
      <strong>Liberté d’expression et vos responsabilités </strong>
    </h5>
    <p>
      Il est complètement interdit de partager dans vos publications un contenu
      discriminatoire, haineux, propagandiste, violent ou d’utiliser ce site à
      des fins commerciales ou autres que des fins pédagogiques.
    </p>
    <p>
      Le CCDMD se réserve le droit de supprimer sans avertissement préalable et
      à tout moment le contenu signalé comme inapproprié, offensant, raciste,
      sexiste, homophobe ou discriminatoire. Les comptes d'usagers dont des
      comportements ont été signalés pour harcèlement, usurpation de l'identité
      et non-respect de ces conditions d'utilisation seront supprimés.
    </p>
    <h5 class="mb-3 mt-5">
      <strong>
        Règles de sécurité concernant l’utilisation du site Dlibr.ccdmd.qc.ca
      </strong>
    </h5>
    <p>
      Il est complètement interdit de nuire au service, ou de tenter de violer
      ou de violer la sécurité et l’intégrité de cet environnement numérique.
    </p>
    <h5 class="mb-3 mt-5">
      <strong>Pour plus d'information </strong>
    </h5>
    <p>
      Si vous souhaitez obtenir plus de renseignements, communiquez avec le
      CCDMD par courriel (info@ccdmd.qc.ca) ou par téléphone (514 873-2200).
    </p>
  </div>
</template>
<script>
/**
 * @file       Usage condition component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "conditions"
};
</script>
